<template>
  <v-container fluid>
    <v-row>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark v-on="on">Add New Suppress</v-btn>
        </template>
        <v-card>
          <app-title>Customer Suppress</app-title>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col md="4">
                  <v-text-field
                    label="Run ID"
                    persistent-hint
                    hint="Use a 0 to suppress always"
                    required
                    v-model="suppress.runId"
                  ></v-text-field>
                </v-col>
                <v-col md="4">
                  <v-select
                    label="Run Type"
                    :items="types"
                    item-value="value"
                    item-text="text"
                    required
                    v-model="suppress.runType"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="4">
                  <v-text-field
                    v-model="suppress.dealerid"
                    label="Dealer ID"
                    required
                  ></v-text-field>
                </v-col>
                <v-col md="4">
                  <v-text-field
                    v-model="suppress.custno"
                    label="Customer Number"
                  ></v-text-field>
                </v-col>
                <v-col md="4">
                  <v-text-field
                    v-model="suppress.csn"
                    label="CSN"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" @click.native="close()">Close</v-btn>
            <v-btn
              color="blue darken-1"
              @click.native="
                save();
                dialog = false;
              "
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-col>
        <v-col cols="4">
          <v-text-field
            name="Search"
            label="Search"
            v-model="search"
            append-icon="search"
          ></v-text-field>
        </v-col>
        <v-data-table
          :search.sync="search"
          :headers="headers"
          :items="details"
          class="elevation-1"
          item-key="id"
          loading="true"
          v-model="selected"
          dense
          show-select
          :single-select="false"
          @item-selected="choose"
        >
          <template v-slot:top>
            <v-btn
              small
              color="primary"
              dark
              @click="deleteRows"
              :disabled="selected.length == 0"
              >Remove Selected</v-btn
            >
          </template>
          <template v-slot:item="{ item, select, isSelected, index, headers }">
            <tr
              @click.left.exact="select($event)"
              @click.left.shift.prevent="selectMulti(item)"
            >
              <td>
                <v-simple-checkbox
                  color="green"
                  :value="isSelected"
                  @input="select($event)"
                ></v-simple-checkbox>
              </td>
              <td
                v-for="(name, index) in headers.filter(
                  x => !['data-table-select', 'action'].includes(x.value)
                )"
                :class="`text-xs-${name.align}`"
                :key="index"
              >
                <span v-if="name.value == `amount`"
                  >${{ item[name.value] | formatMoney }}</span
                >
                <span v-else>{{ item[name.value] }}</span>
              </td>
              <td>
                <v-icon small class="mr-2" @click="editRow(item)">edit</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "CommissionSuppress",
  props: {
    details: {
      type: Array,
      required: true
    },
    runId: Number,
    runType: Number
  },
  data() {
    return {
      search: null,
      selected: [],
      suppress: {
        dealerid: 0,
        custno: 0,
        csn: "",
        runId: this.runId,
        runType: this.runType
      },
      dialog: false,
      loading: false,
      types: [
        {
          value: 1,
          text: "Initial"
        },
        {
          value: 2,
          text: "Royalty"
        }
      ],
      headers: [
        {
          text: "Dealer",
          value: "dealerid",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80
        },
        {
          text: "Customer Number",
          value: "custno",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80
        },
        {
          text: "CSN",
          value: "csn",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80
        },
        {
          text: "Run ID",
          value: "runId",
          align: "left",
          sortable: true,
          class: ["strong"],
          width: 80
        },
        {
          text: "Action",
          value: "action",
          align: "center",
          sortable: false,
          class: ["strong"],
          width: 80
        }
      ]
    };
  },
  watch: {
    dialog: function(val) {
      if (val)
        if (this.suppress.custNo === 0)
          this.suppress = {
            dealerid: 0,
            custno: 0,
            csn: "",
            runId: this.runId,
            runType: this.runType,
            ratePlanId: 0
          };
    }
  },
  methods: {
    ...mapActions("commissions", ["CommissionsRequest"]),
    close() {
      this.dialog = false;
      this.suppress = {
        dealerid: 0,
        custno: 0,
        csn: "",
        runId: this.runId,
        runType: this.runType,
        ratePlanId: 0
      };
    },
    choose(event) {
      this.currentRow = this.details.indexOf(event.item);
      let found = this.selected.indexOf(event.item);
      if (found < 0) this.selected.push(event.item);
      else this.selected.splice(found, 1);
    },
    selectMulti(item) {
      let endRow = this.details.indexOf(item);
      for (let index = this.currentRow + 1; index <= endRow; index++) {
        let found = this.selected.indexOf(this.details[index]);
        if (found < 0) this.selected.push(this.details[index]);
        else this.selected.splice(found, 1);
      }
    },
    save() {
      let query = {
        message: "Suppressed Customers added",
        url: `Commissions/EditSuppressed/`,
        method: "post",
        body: [this.suppress]
      };
      this.CommissionsRequest(query)
        .then(() => {
          this.suppress = {
            dealerid: 0,
            custno: 0,
            csn: "",
            runId: this.run.runId,
            runType: this.run.runType,
            ratePlanId: 0
          };
          this.$emit("saved");
        })
        .catch(() => {});
    },
    editRow(val) {
      this.suppress = val;
      this.dialog = true;
    },
    deleteRows() {
      let query = {
        message: "Suppressed Customers deleted",
        url: `Commissions/DeleteSuppressed/`,
        method: "post",
        body: this.selected
      };
      this.CommissionsRequest(query)
        .then(() => {
          this.selected = [];
          this.$emit("edited");
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped></style>
